var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"tip"},[_vm._v(" 请使用微信扫码，绑定该账号 "),_c('span',{staticClass:"iconfont iconmima"})]),_c('div',{staticClass:"imgbox",attrs:{"id":"login_wx"}})])
}]

export { render, staticRenderFns }